<template>
    <div>
        <div class="card left">
            <div class="card-body">

            </div>
        </div>
        <div class="card right">

            <div class="card-body ">
                <table class="table table-striped" v-loading="loading">
                    <thead>
                    <tr>
                        <th>工号</th>
                        <th>姓名</th>
                        <th>管理年级</th>
                        <th>联系方式</th>
                        <th>名下学生人数</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in headTeachers">
                        <td>{{item.id}}</td>
                        <td>{{item.employee.name}}</td>
                        <td>{{item.grade}}</td>
                        <td>{{item.employee.phone}}</td>
                        <td>{{item.student.number}}</td>
                        <td>
                            <el-button size="mini" @click="handleHeadTeacherInformation(item)">查看详情</el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <!--分页-->
                <div class="text-center m-t-10">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
<script>
    import store from '@/store'

    export default {
        name: "headTeacher-list",
        data() {
            return {
                loading: 'true',
                headTeachers: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 20
            }
        },
        props: {},
        mounted() {
            this.$nextTick(() => {
                this.loading = false
            })
        },
        created() {
            this.handleIndexHeadTeacher();
            this.handleHeadTeacherListListen();
        },
        methods: {
            handleHeadTeacherListListen() {
                this.$Echo.private('headTeacherList')
                    .listen('.headTeacherInformationListUpdate', (e) => {
                        this.$set(this.headTeachers, e.headTeacher_id, e.headTeacher);
                    })

            },

            handleIndexHeadTeacher(currentPage = 1, currentPageSize = 10) {
                this.$axios.get(store.state.server + '/headTeacherList?currentPage=' + currentPage + '&currentPageSize=' + currentPageSize + '&' + localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.headTeachers = response.data.data.headTeachers
                        this.total = response.data.data.total
                    }
                })
            },
            handleHeadTeacherInformation(headTeacher) {
                this.$store.commit('addTab', {
                    targetName: 'headTeacher-information',
                    parameter: headTeacher.id,
                    title: headTeacher.employee.name
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndexHeadTeacher(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleIndexHeadTeacher(this.currentPage, this.currentPageSize)
            }
        }
    }
</script>
